var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRentalProduct)?_c('rent-configurable-product'):_c('buy-configurable-product')}
var staticRenderFns = []

export { render, staticRenderFns }